import { render } from "./Error404View.vue?vue&type=template&id=025cf723"
const script = {}

import exportComponent from "C:\\Users\\hozha\\OneDrive\\Desktop\\partak\\appalloemail\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__